<template>
  <div class="vm-contact">
    <div class="vm-avatar">
      <template v-if="avatar">
        <img :src="avatar" style="width:100%; height:100%; border-radius:50%; object-fit: scale-down;"/>
      </template>
      <template v-else>
        <div class="initials">{{ initials }}</div>
      </template>
    </div>
    <div class="vm-info">
      <div class="vm-name">
        {{ firstName }} {{ lastName }}
      </div>
      <div style="display:flex; margin-left:auto">
      <div v-if="!endpoint" class="stat">
        Не подписан
      </div>
      <div v-if="status" class="vm-status">
        <span v-if="status === 'send'" class="vm-status__send">Отправлен</span>
        <span v-if="status === 'not_send'" class="vm-status__not-send">Не отправлено</span>
        <span v-if="status === 'not_subscribe'" class="vm-status__not-subscribe">Не подписан</span>
      </div>
      <div v-else class="vm-toggle" :class="{ selected, 'dis': !endpoint }" @click="$emit('toggle')">
        <i v-if="selected" class="material-icons">check</i>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    uuid: String,
    avatar: String,
    firstName: String,
    lastName: String,
    selected: Boolean,
    status: String,
    endpoint: String,
  },
  computed: {
    initials() {
      const first = this.firstName ? this.firstName.charAt(0) : '';
      const last = this.lastName ? this.lastName.charAt(0) : '';
      return first + last;
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-status {
  margin-left: auto;
}
.vm-status span {
  display: block;
  line-height: 36px;
  border-radius: 18px;
  font-size: 12px;
  text-transform: uppercase;
  padding: 0 12px;
  color: #fff;
  font-weight: 300;
}
.vm-status__send {
  background-color: #8bc34a;
}
.vm-status__not-send {
  background-color: #db4437;
}
.vm-status__not-subscribe {
  background-color: #fab34b;
}
.vm-contact {
  padding: 6px 24px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}
.vm-avatar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: #5742cc1a;
  font-weight: 500;
  font-size: 14px;
  color: #fff;
}
.vm-info {
  flex: auto;
  margin-left: 12px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0,0,0,.08)
}
.vm-toggle {
  width: 24px;
  height: 24px;
  border: 1px solid #5c48d4;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  transition: all 300ms ease;
  margin-left: auto;
  cursor: pointer;
}
.vm-toggle i {
  font-size: 16px;
}
.vm-toggle.selected {
  background: #5c48d4;
  background-color: #5c48d4;
}
.dis {
  background: lightgray;
  pointer-events: none;
}
.stat {
  margin-right: 1rem;
  font-size: 14px;
}
</style>